import FirePointFive from '../breath/fivePointFive/firePointFive'

function Breath(props) {

    return  <FirePointFive  />
}

export default Breath